import './css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from './common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { checkLogin } from '../store';
import { SyncLoader } from "react-spinners";
import Message from './common/message';

import { changeNum } from './common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function GameSetting() {
    const [reload, setReload] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [message, setMessage] = useState({ code: -1, msg: "" })

    let dark = useSelector((state) => { return state.Darkmode.value });

    const [data, setData] = useState([])

    const [changeValue, setChangeValue] = useState(false)

    const darkname = dark ? 'dark' : "";

    let dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/')
            }
            else {
                dispatch(checkLogin(true));
            }
        }
        else {
            dispatch(checkLogin(false));
            navigate('/')
        }
    }, [])

    useEffect(() => {
        UpgradeData()
    }, [reload])

    const [inputValues, setInputValues] = useState([]);

    useEffect(() => {
        if (data?.length) {
            setInputValues(data.map((item) => ({ id: item.id, value: item.value })));
        }
    }, [data]);

    const handleInputChange = (id, value) => {
        setInputValues((prev) =>
            prev.map((item) => (item.id === id ? { ...item, value } : item))
        );
    };

    const UpgradeData = async () => {
        setSpinner(true)
        await axios.get(process.env.REACT_APP_API + '/api/setting', {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setData(tmp?.data?.setting ?? [])
                setSpinner(false)
            }
            else setSpinner(false)
        }).catch((error) => {
            console.log(error)
        })
    };

    const onSubmitUpdate = async () => {
        await axios.post(process.env.REACT_APP_API + '/api/setting', {
            settings: inputValues
        }, {
            // headers: { Authorization: `Bearer ${JWT}` }
        }).then((response) => {
            let tmp = response.data
            if (tmp?.code == 1000) {
                setChangeValue(false)
                setReload(e => !e)
            }
        }).catch((error) => {
            console.log(error)
        })
    };

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`} style={{ width: "1200px" }}>
                <div className='table-flex'>
                    <div className={`member-2 ${darkname}`} >
                        <div className={`table-head ${darkname}`}>
                            <div style={{ width: "1%", minWidth: "50px" }}>no.</div>
                            <div style={{ width: "15%", minWidth: "150px" }}>밸류</div>
                            <div style={{ width: "20%", minWidth: "250px" }}>형식</div>
                            <div style={{ width: "49%", minWidth: "350px" }}>설명</div>
                        </div>
                        <div className='table-body' style={{ minHeight: "320px" }}>
                            {
                                spinner
                                    ?
                                    <div className='spinner-modal'>
                                        <SyncLoader color="#003577" />
                                    </div>
                                    :
                                    data.length === 0
                                        ?
                                        <div className='data-nofound'>
                                            <img src='/img/img_nofound.png'></img>
                                            <img src='/img/img_nofound_dark.svg' style={{ display: "none" }}></img>
                                            <p>NO RECORDS FOUND</p>
                                        </div>
                                        :
                                        <>
                                            {
                                                data.map(function (a, i) {
                                                    return (
                                                        <MemberItem
                                                            key={i}
                                                            item={a}
                                                            seq={i + 1} // 역순 계산
                                                            darkname={darkname}
                                                            dark={dark}
                                                            changeValue={changeValue}
                                                            handleInputChange={handleInputChange}
                                                        />
                                                    )
                                                })
                                            }
                                        </>
                            }
                        </div>
                        <div className='gameSetting-btn-1'>
                            {
                                changeValue
                                    ?
                                    <>
                                        <div className='gameSetting-btn-2' onClick={() => setChangeValue(false)}>취소</div>
                                        <div className='gameSetting-btn-2' onClick={() => onSubmitUpdate()}>저장</div>
                                    </>
                                    :
                                    <div className='gameSetting-btn-2' onClick={() => setChangeValue(true)}>수정</div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function MemberItem({ item, seq, darkname, dark, changeValue, handleInputChange }) {
    const [inputValue, setInputValue] = useState(() => {
        if (item.value.includes(":")) {
            const [first, second] = item.value.split(":");
            return { first, second };
        }
        return { first: item.value, second: null };
    });

    const onChangeFirstValue = (e) => {
        const { value } = e.target;
        const validValue = value.replace(/[^0-9.]/g, ""); // 숫자와 소수점만 허용
        setInputValue((prev) => ({ ...prev, first: validValue }));
        handleInputChange(item.id,
            inputValue.second ? `${validValue}:${inputValue.second}` : validValue);
    };

    const onChangeSecondValue = (e) => {
        const { value } = e.target;
        const validValue = value.replace(/[^0-9.]/g, ""); // 숫자와 소수점만 허용
        setInputValue((prev) => ({ ...prev, second: validValue }));
        handleInputChange(item.id, `${inputValue.first}:${validValue}`);
    };

    return (
        <>
            <div className={`table-body-tr ${darkname}`}>
                <div className="td" style={{ width: "1%", minWidth: "50px" }}>{seq}</div>
                {
                    changeValue
                        ?
                        <div className="td" style={{ width: "15%", minWidth: "150px", display: "flex", gap: "5px" }}>
                            <input
                                value={inputValue.first}
                                onChange={onChangeFirstValue}
                                placeholder="값 입력"
                                style={{ width: inputValue.second ? "45%" : "80%", padding: "3px" }}
                            />
                            {
                                inputValue.second
                                    ?
                                    <>
                                        <span>:</span>
                                        <input
                                            value={inputValue.second}
                                            onChange={onChangeSecondValue}
                                            placeholder="값 입력"
                                            style={{ width: "45%", padding: "3px" }}
                                        />
                                    </>
                                    :
                                    ""
                            }
                        </div>
                        :
                        <div className="td" style={{ width: "15%", minWidth: "150px" }}>
                            {
                                !isNaN(Number(item.value))
                                    ? changeNum(Number(item.value)) // 숫자로 변환 가능하면 changeNum() 호출
                                    : item.value // 변환 불가능하면 그대로 출력
                            }
                        </div>
                }
                <div className="left td" style={{ width: "20%", minWidth: "250px" }}>{item.format}</div>
                <div className="left td" style={{ width: "49%", minWidth: "350px" }}>
                    {item.desc}
                    {item.id === 999 &&
                        <span style={{ color: 'red', display: 'block' }}>
                            &nbsp;&nbsp;* 최소 설정 가능치 0.001 : 변경 시 에어드랍이 실행되지 않을 수 있습니다
                        </span>
                    }
                </div>
            </div>
        </>
    );
}

export default GameSetting;